module.exports = __webpack_public_path__ + "img/ShaderEditorBasicTexture.0a8ac9c1.gif";